import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import useLenis from "@/hooks/useLenis";
import { AppointmentProvider } from "@/components/AppointmentContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Therapists from "@/pages/Therapists";
import CBT from "@/pages/CBT";
import Contact from "@/pages/Contact";
import InsuranceFees from "@/pages/InsuranceFees";
import Resources from "@/pages/Resources";
import BlogArticle from "@/pages/BlogArticle";
import ServicePage from "@/pages/ServicePage";
import Pediatric from "@/pages/Pediatric";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

import { SERVICES, CONDITIONS_DATA } from "@/data/services";

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <AppointmentProvider>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/therapists" element={<Therapists />} />
                    <Route path="/cognitive-behavioral-therapy" element={<CBT />} />
                    <Route path="/pediatric-psychotherapy" element={<Pediatric />} />
                    <Route path="/insurance-and-fees" element={<InsuranceFees />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/resources" element={<Resources />} />
                    <Route path="/resources/:slug" element={<BlogArticle />} />

                    {Object.entries(SERVICES).map(([slug, data]) => (
                      <Route key={slug} path={`/${slug}`} element={<ServicePage slug={slug} data={data} />} />
                    ))}
                    {Object.entries(CONDITIONS_DATA).map(([slug, data]) => (
                      <Route key={slug} path={`/${slug}`} element={<ServicePage slug={slug} data={data} />} />
                    ))}

                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </AppointmentProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
